import React from 'react';
import { FormattedMessage } from 'react-intl';

import { FormFieldComponentProps } from '../../../lib/types/types';

const SMSCodeComponent = ({
    onChange,
    value,
    isErrored,
    errorId,
    placeholder = '',
}: FormFieldComponentProps) => {
    const getErrorMessage = (errorId) => {
        switch (errorId) {
            case 'invalidSMSCode':
                return (
                    <FormattedMessage
                        id="step.smsLoop.errors.codeVerification"
                        defaultMessage="Verification code could not be validated."
                    />
                );
            case 'expiredSMSCode':
                return (
                    <FormattedMessage
                        id="step.smsLoop.errors.codeExpired"
                        defaultMessage="Verification code expired."
                    />
                );
            default:
                return (
                    <FormattedMessage
                        id="errorId.unknownError"
                        defaultMessage="Unknown Error"
                    />
                );
        }
    };

    return (
        <div className="sid-field sid-sms-code-id">
            <div className="sid-l-space-top-md" />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        {getErrorMessage(errorId)}
                    </div>
                ) : null
            }
            <input
                className={`sid-text-input sid-text-input--required sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`}
                id="sid-sms-code"
                name="sid-sms-code"
                type="code"
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
            />
        </div>
    );
};

export { SMSCodeComponent };
